import React from 'react'
import Modal from '../../../ui_reusable/Modal'
import { Button } from 'rsuite'

const SwitchClientReportModal = ({
  open,
  onClose,
  onConfirm,
  newValue,
  currentValue,
}) => {
  if (!open) {
    return null
  }

  return (
    <Modal open={open} onClose={onClose} title="Switch Client/Project">
      <Modal.Body>
        <p>
          You are about to switch from <strong>{currentValue}</strong> to{' '}
          <strong>{newValue}</strong>.
        </p>
        <p>
          ⚠️ Your currently selected model will not be available in the new
          client/project.
        </p>
        <p>
          If you continue, your model selection will be reset and you'll need to
          choose a new model.
        </p>
        <p>Are you sure you want to continue?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onConfirm} appearance="primary">
          Continue
        </Button>
        <Button onClick={onClose} appearance="subtle">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SwitchClientReportModal
